export default __webpack_public_path__ + "static/media/DiscoverCard_icon.774d9587.svg";